import { assert } from 'src/packages/utils/assert';

import type { GridColumnGroupingModel, GridColumnGroup } from '@repo/go-table';
import type { TTableView } from 'src/services/directory-service/types';

import { TableHeader } from '../components/table-header';
import { DEFAULT_TABLE_HEADER_ORIENTATION } from '../header-orientation';

export function useGetColumnsGrouping(view: TTableView | null): GridColumnGroupingModel {
  if (!view) {
    return [];
  }

  const groups: GridColumnGroup[] = [];

  const innerColumns = view.columns.at(0)?.innerColumns;

  assert(innerColumns?.length, 'inner column are not presented');

  for (const column of innerColumns) {
    if (!('innerColumns' in column)) {
      continue;
    }

    groups.push({
      groupId: column.fieldId,
      freeReordering: true,
      renderHeaderGroup: () => {
        return (
          <TableHeader textTKey={`labels:${column.fieldId}.label`} orientation={DEFAULT_TABLE_HEADER_ORIENTATION} />
        );
      },
      children: column.innerColumns.map((inCol) => ({ field: inCol.fieldId })),
    });
  }

  return groups;
}
